export default "__VITE_ASSET__a5af9cad__"